export default "__VITE_ASSET__B$Z4wpgw__"